import { render, staticRenderFns } from "./Cargar.vue?vue&type=template&id=361b0681&scoped=true"
import script from "./Cargar.vue?vue&type=script&lang=js"
export * from "./Cargar.vue?vue&type=script&lang=js"
import style0 from "./Cargar.vue?vue&type=style&index=0&id=361b0681&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361b0681",
  null
  
)

export default component.exports